import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent, IonFooter, IonHeader } from '@ionic/react'
import { ProductImage, UseTextArea } from '@cps'
import { cartMobx, restaurantConfig, storeMobx } from 'restaurant'
import { checkoutMobx } from '@mobxStore'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { toJS } from 'mobx'
import './index.scss'

interface IProps {
  reject?: any;
  resolve?: any;
}

const CatProductRemark: FC<IProps> = (props) => {
  // 后付费已下单不能再修改整单备注
  const cannotRemarkOrder = !!cartMobx.ordersId
  const { reject, resolve } = props
  // const [_remarkStatus, setRemarkStatus] = useState(cannotRemarkOrder)
  // const [_remarkInfos, setRemarkInfos] = useState({ order: '' } as any)
  // const optionModify = (cartItem: IViewCartItem) => {
  //   if (cartItem.optionStr || cartItem.modifierStr) {
  //     <span>{cartItem.optionStr}{cartItem.optionStr && cartItem.modifierStr ? ',' : ''}{cartItem.modifierStr}</span>
  //   }
  //   return null
  // }
  // useEffect(() => {
  //   if (cartMobx.cartProductHasReamrkStatus) {
  //     setRemarkStatus(true)
  //   }
  //   let obj: Record<string, string> = {
  //     order: toJS(cartMobx.info.remark || '')
  //   }
  //   toJS(cartMobx.cartItems).forEach(carteItem => {
  //     obj[carteItem.pk] = carteItem.remark || ''
  //   })
  //   setRemarkInfos(obj)
  // }, [])
  // const handleChange = (value: string, key: string) => {
  //   if (_remarkInfos[key] !== undefined) {
  //     setRemarkInfos({
  //       ..._remarkInfos,
  //       [key]: value
  //     })
  //   }
  // }
  // const saveReamrk = () => {
  //   if (cartMobx.info.remark !== (_remarkInfos.order || '')) {
  //     cartMobx.setRemark(_remarkInfos.order || '')
  //   }
  //   if (_remarkStatus) {
  //     cartMobx.setCartProductRemark(_remarkInfos)
  //   }
  //   resolve()
  // }
  const { remarkInfo, setRemarkInfo } = checkoutMobx
  const [remarkInfos, setRemarkInfos] = useState({
    list: [],
    custom: ''
  } as any)

  const handleQuickly = (value: string) => {
    const list = cloneDeep(remarkInfos.list)
    const idx = list.indexOf(value)
    if (idx > -1) {
      list.splice(idx, 1)
    } else {
      list.push(value)
    }
    setRemarkInfos({
      ...remarkInfos,
      list,
    })
  }

  const handleChange = (value: string) => {
    setRemarkInfos({
      ...remarkInfos,
      custom: value
    })
  }

  const handleSaveRemark = (e: any) => {
    e.stopPropagation()
    try {
      setRemarkInfo(remarkInfos)
    } catch (error) {
    }
    resolve()
  }

  useEffect(() => {
    setRemarkInfos({
      list: remarkInfo.list,
      custom: !(remarkInfo.list?.length || remarkInfo.custom) ? cartMobx.info.remark : remarkInfo.custom || ''
    })
  }, [])

  return (
    <IonModal
      isOpen
      cssClass='remark-modal'
      swipeToClose
      onDidDismiss={() => reject()}
    >
      <IonHeader>
        <div className='remark-title'>
          <span>{i18n.t('newCart.remark')}</span>
          <i className='iconfont icon-close' data-cypid='remarkModalClose' onClick={() => reject()}></i>
        </div>
      </IonHeader>
      <IonContent className='remark-content' scrollEvents>
        <div className='remark-modal-content'>
          {
            !cannotRemarkOrder && (
              <div className='remark-all-remark'>
                {
                  storeMobx.info.quicklyRemarkConfig?.list?.length ? (
                    <div className='remark-quickly'>
                      {storeMobx.info.quicklyRemarkConfig.list.map((item, index) => {
                        const selected = remarkInfos.list?.includes(item)
                        return <span className={`remark-quickly-item ${selected ? 'selected' : ''}`} data-cypid={`remarkModal_${index}`} key={index} onClick={() => handleQuickly(item)}>{item}</span>
                      })}
                    </div>
                  ) : null
                }
                {/* <span className='remark-name'>{i18n.t('cart.allproduct')}</span> */}
                <UseTextArea
                  maxLength={50}
                  value={remarkInfos.custom}
                  showLength={1}
                  autohHeight
                  placeholder={i18n.t('newCart.remarkPlacechoder')}
                  onChange={(e: any) => handleChange(e)}
                />
              </div>
            )
          }
          {/* {
            !cannotRemarkOrder && (
              <div className={`remark-spread ${_remarkInfos.order?.length >= 118 ? 'showlen' : ''}`}>
                {i18n.t('cart.canyouremark')}
                <span onClick={() => setRemarkStatus(!_remarkStatus)}>{!_remarkStatus ? i18n.t('cart.out') : i18n.t('cart.up')}</span>
              </div>
            )
          } */}
          {/* {_remarkStatus ? (
            <div className='remark-product-warp'>
              {cartMobx.viewCartItems.map(cartItem => {
                return (
                  <div className='remark-product-detail' key={cartItem.pk}>
                    <div className='remark-product-info'>
                      <ProductImage color={!cartItem.pic && restaurantConfig.displayMode === 'waterfall' ? cartItem.productNo : ''} imgSrc={cartItem.pic} width={48} />
                      <div className='product-info'>
                        <strong>{cartItem.name}</strong>
                        {optionModify(cartItem)}
                      </div>
                    </div>
                    <UseTextArea
                      maxLength={128}
                      value={_remarkInfos[cartItem.pk] || ''}
                      showLength={118}
                      autohHeight
                      placeholder={i18n.t('cart.remartplacechoder')}
                      onChange={(e: any) => handleChange(e, cartItem.pk)}
                    />
                  </div>
                )
              })}
            </div>
          ) : null} */}
        </div>
      </IonContent>
      <IonFooter className='remark-footer'>
        <div className='remark-button' data-cypid='remarkModalConfirm' onClick={handleSaveRemark}>{i18n.t('common.save')}</div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(CatProductRemark)
